import spl_logo from "../assets/images/bg_free_spl_logo.png";
import '../styles/Intro.css';
import '../styles/App.css';
import InstructionsDialog from './InstructionsDialog.jsx'


// Component for intro-section
const Intro = () => (
  <header className="header">

    <img src={spl_logo} alt="SPL Logo" className="logo" />

    <h1>LIPPUJEN KÄYTTÄJIEN YHTEYSTIETOJEN TÄYTTÄMINEN</h1>

    <div className="description">

        <p className="p1">
            Tällä sivulla näet tilaamasi liput maaotteluihin ja voit antaa lippujen käyttäjien sähköpostiosoitteen muokkaamalla tietoja. 
            <br />Mikäli lipun käyttäjä on vastaanottanut kirjeitämme, lähetämme myös hänelle otteluun liittyvää viestintää.
        </p>

        <p className="p2">
            Huom! Varmista, että sinulla on lipun käyttäjän suostumus antaa hänen sähköpostiosoitteensa.
        </p>

        <p className="p3">
            Lasten lippujen osalta täytä kenttään aikuisen sähköpostiosoite.
        </p>

        <p className="p4">
            Voit lukea asiakastietojen käsittelystä <a href="https://www.palloliitto.fi/tietosuoja/asiakastietojen-tietosuojaseloste" target="_blank" rel="noopener noreferrer">tietosuojaselosteestamme</a>.
        </p>

    </div>

    <InstructionsDialog />
    
  </header>
);

export default Intro;